import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Target, Users, Zap, Globe } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-white">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-6">About NebiusFlow</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-600 mb-8">
              NebiusFlow is a modern task management application designed to help individuals and teams 
              organize their work efficiently. Built with cutting-edge technology and deployed on 
              Cloudflare's global edge network, NebiusFlow delivers exceptional performance worldwide.
            </p>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <Target className="w-12 h-12 text-primary-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">Our Mission</h3>
                <p className="text-gray-600">
                  To provide a simple yet powerful task management solution that helps people 
                  achieve their goals and stay organized in an increasingly complex world.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <Users className="w-12 h-12 text-primary-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">Built for Everyone</h3>
                <p className="text-gray-600">
                  Whether you're a solo entrepreneur, a student, or part of a large team, 
                  NebiusFlow adapts to your workflow and helps you stay productive.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <Zap className="w-12 h-12 text-primary-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">Lightning Fast</h3>
                <p className="text-gray-600">
                  Deployed on Cloudflare's edge network, NebiusFlow delivers sub-50ms response 
                  times globally, ensuring a smooth experience no matter where you are.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <Globe className="w-12 h-12 text-primary-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">Global Reach</h3>
                <p className="text-gray-600">
                  With data centers in over 200 cities worldwide, your tasks are always 
                  accessible, secure, and synchronized across all your devices.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-bold mb-4">Technology Stack</h2>
            <p className="text-gray-600 mb-4">
              NebiusFlow is built with modern, enterprise-grade technologies:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>React 18 with Vite for a responsive, modern UI</li>
              <li>Cloudflare Workers for serverless backend</li>
              <li>D1 Database for reliable data storage</li>
              <li>JWT authentication for secure access</li>
              <li>Tailwind CSS for beautiful, consistent design</li>
            </ul>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutPage;
          
